/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddRuleset/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import Info from 'DesignSystem/Info/index'
import MaxLength from './MaxLength/index'
import MinDownpayment from './MinDownpayment/index'
import React from 'react'
import SubTitle from 'DesignSystem/SubTitle/index'
import TxPlanGroupChooser from './TxPlanGroupChooser/index'
import TxPlanGroups from './TxPlanGroups/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AddRuleset({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCaseCloser/Configuration/CustomPlanRulesets/AddRuleset"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtTypographyFontsizeS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.s'
        })
let dtTypographyLineheightM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.lineHeight.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="AddRuleset.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-1mrkAP': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--mr-2-1mrkAP': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bbc-3-1mrkAP': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="AddRuleset.Vertical"
  data-view-path={viewPath}
 style={{'--mr-2-1mrkAP': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical}`}
>
<SubTitle
  viewPath={`${viewPath}/SubTitle`}
 text="New ruleset"
/>
<Info
  viewPath={`${viewPath}/Info`}
 marginTop={dtSpaceS}
 whiteSpace="wrap"
 hyphens="none"
 fontSize={dtTypographyFontsizeS}
 lineHeight={dtTypographyLineheightM}
 text="Add a new custom payment plan ruleset for one or more treatment plan groups."
/>
</div>
<div
  data-testid="AddRuleset.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="AddRuleset.Vertical:2"
  data-view-path={viewPath}
 style={{'--bblr-4-1mrkAP': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-5-1mrkAP': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-6-1mrkAP': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-7-1mrkAP': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-8-1mrkAP': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-9-1mrkAP': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-10-1mrkAP': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-11-1mrkAP': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-12-1mrkAP': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical2}`}
>
<TxPlanGroupChooser
  viewPath={`${viewPath}/TxPlanGroupChooser`}
/>
<TxPlanGroups
  viewPath={`${viewPath}/TxPlanGroups`}
/>
<MinDownpayment
  viewPath={`${viewPath}/MinDownpayment`}
/>
<MaxLength
  viewPath={`${viewPath}/MaxLength`}
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}